import type { ApolloClient } from '@apollo/client/core';
import { Injectable, OnDestroy } from '@angular/core';
import { onlyCompleteData } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GraphQLData } from './common/graphql.data';

@Injectable()
export class GraphQLQuery extends GraphQLData implements OnDestroy {
	// Single (one-shot) query
	query<T>(doc?: DocumentNode, opts?: Partial<ApolloClient.QueryOptions<T>>): Observable<T> {
		return this.apollo
			.query<T>({
				query: doc ?? this.command,
				variables: this.vars,
				...opts,
			})
			.pipe(
				map((response) => response.data),
				catchError((e) => this.handleError(e)),
			);
	}

	// Watch query (live updates)
	watchQuery<T>(doc?: DocumentNode, opts?: Partial<ApolloClient.WatchQueryOptions<T>>): Observable<T> {
		return this.apollo
			.watchQuery<T>({
				query: doc ?? this.command,
				variables: this.vars,
				...opts,
			})
			.valueChanges.pipe(
				onlyCompleteData(),
				map((response) => response.data),
				catchError((e) => this.handleError(e)),
			);
	}
}
